// import qs from "qs"
// import Jsona from "jsona"
// import ApiService from "@/store/services/api.service"
import ApiService from "./api.service"

export const SettingService = {
  list() {
    return ApiService.get(`settings`)
  },
}
